import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class ProductTypeService extends BaseService {

    static url = "product_types";
    static apis = {
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("product_types");
    }


}

export default ProductTypeService;